import MasterService from "./MasterService";

export const ConfigPanelService = {
    ...MasterService,

    getMasterConfig() {
        return this.post('/config-panel/master-config')
    },
    saveBankConfig(params: any) {
        return this.post('/config-panel/save-bank-config',params)
    },
    getBankConfig(params: any) {
        return this.post('/config-panel/get-bank-config',params)
    },
    getBankList() {
        return this.get('/config-panel/bank-list')
    },
    deleteBankRow(params: any) {
        return this.post('/config-panel/delete-bank-row',params)
    },
}